"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiHost = void 0;
function getApiHost(host) {
    const parsed = host.split('.');
    if (parsed.length < 2) {
        return host;
    }
    const lastPart = parsed[parsed.length - 1];
    const mainPart = parsed[parsed.length - 2];
    const branchPart = parsed[parsed.length - 3];
    if (host === 'rb.m2' || host === 'm2.region.vtb.ru') {
        return `${host}/.proxy/api.m2.ru`;
    }
    if (mainPart === 'm2') {
        return `api.${mainPart}.${lastPart}`;
    }
    if (branchPart) {
        const suffix = 'branch-';
        const suffixIndex = branchPart.indexOf(suffix);
        if (suffixIndex !== -1) {
            const branch = branchPart.substr(suffixIndex + suffix.length);
            return `api-${suffix}${branch}.${mainPart}.${lastPart}`;
        }
    }
    return `api.${mainPart}.${lastPart}`;
}
exports.getApiHost = getApiHost;
//# sourceMappingURL=index.js.map